import React from 'react';

const Footer = ({ onNavigate }) => {
  return (
    <div style={{
      marginTop: 'auto', 
      padding: '20px', 
      textAlign: 'center', 
      borderTop: '1px solid #ddd',
      backgroundColor: '#f8f9fa',
      color: '#666',
      fontSize: '0.9rem'
    }}>
      <div style={{marginBottom: '10px'}}>
        <span 
          onClick={() => onNavigate('tos')} 
          style={{cursor: 'pointer', marginRight: '15px', textDecoration: 'underline'}}
        >
          Terms of Service
        </span>
        <span 
          onClick={() => onNavigate('feedback')} 
          style={{cursor: 'pointer', textDecoration: 'underline'}}
        >
          Report Bug / Feedback
        </span>
      </div>
      <div>
        &copy; {new Date().getFullYear()} Songbook App
      </div>
    </div>
  );
};

export default Footer;